module.exports = __webpack_public_path__ + "static/BT-mobile-8-7c0d2f00fc085c563ba865b1f3687b69.jpg";